import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

export type MarketingCampaignDetailsDependencies = {
  campaign: any
};

@Component({
  selector: 'app-marketing-campaign-details',
  templateUrl: './marketing-campaign-details.component.html',
  styleUrls: ['./marketing-campaign-details.component.scss']
})
export class MarketingCampaignDetailsComponent {

  protected campaign: any;

  constructor(
      @Inject(MAT_DIALOG_DATA) public data: MarketingCampaignDetailsDependencies) {
    this.campaign = data.campaign;
  }
}
